/**
 * This function generates a greeting message based on the current time of day
 * 
 * @returns {string} A greetings message
 */
function generateGreetingsMessage() {
  const hour = new Date().getHours();

  if (hour >= 6 && hour < 12) return "Good morning!"; // between 6AM and 11:59AM
  if (hour >= 12 && hour < 18) return "Good afternoon!"; // between 12PM and 5:59PM
  return "Good evening!"; // between 6PM and 5:59AM
}

export { generateGreetingsMessage };
